import { TOV_QUERY_ROOTS } from "../enums/shell";

/**
 * Whether a cached query is a Client tone-of-voice read, decided by the
 * registered namespace it was filed under.
 */
export function isTovQuery(queryKey: readonly unknown[]): boolean {
  const [root] = queryKey;
  return TOV_QUERY_ROOTS.some((candidate) => candidate === root);
}
